module.exports = __webpack_public_path__ + "static/img/spot_order_empty.340674dc.png";